/**
 * @author: dongjing
 * @file: description
 * @Date: 1985-10-26 16:15:00
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-13 21:13:58
 */
import { Action } from '@tkit/actions';

import initialState, { IInitialState } from './initialState';
import { default as doActiveModel } from './activeModel';

type Reducer = <P>(state: IInitialState, action: Action<P>) => IInitialState;
const reducers: any[] = [doActiveModel.reducers];
export default function reducer<P>(state = initialState, action: Action<P>): IInitialState {
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      state = { ...state };
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => (r as Reducer)(s, action), state);
}
